import axios from 'axios'
import _ from 'lodash'
import Swal from 'sweetalert2'

const handleAuthError = (status) => {
  if (status === 401 || status === 403) {
    // Save current path for redirect after login
    const currentPath = window.location.pathname
    if (currentPath !== '/login') {
      localStorage.setItem('redirectAfterLogin', currentPath)
    }

    // Clear auth data
    localStorage.removeItem('userData')
    localStorage.removeItem('userToken')
    localStorage.removeItem('permissionId')

    if (status === 401) {
      // Unauthorized - token expired or invalid
      window.location.href = '/login'
    } else {
      // Forbidden - user doesn't have required permissions
      window.location.href = '/unauthorized'
    }
    return true
  }
  return false
}

const ApiCaller = {
  serialize: obj => {
    const str = []
    for (const p in obj) {
      if (obj.hasOwnProperty(p) && obj[p] !== undefined && obj[p] !== '') {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    }
    return str.join('&')
  },

  post: async (jsonObj = {}, path = '', token = '') => {
    try {
      const url = process.env.REACT_APP_API_BASE_URL + path
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(jsonObj),
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? 'Bearer ' + token : ''
        }
      })

      // Check for auth errors before processing response
      if (handleAuthError(res.status)) {
        return { response: res, status: res.status }
      }

      // Clone response before reading
      const clonedRes = res.clone()
      return { response: clonedRes, status: res.status }
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

  get: async (jsonObj = {}, path = '', token = '') => {
    try {
      let query = await ApiCaller.serialize(jsonObj)
      const url =
        query !== ''
          ? process.env.REACT_APP_API_BASE_URL + path + '?' + query
          : process.env.REACT_APP_API_BASE_URL + path

      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? 'Bearer ' + token : ''
        }
      })

      // Check for auth errors before processing response
      if (handleAuthError(res.status)) {
        return { response: res, status: res.status }
      }

      // Clone response before reading
      const clonedRes = res.clone()
      return { response: clonedRes, status: res.status }
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

  put: async (jsonObj = {}, path = '', token = '') => {
    try {
      const url = process.env.REACT_APP_API_BASE_URL + path
      const res = await fetch(url, {
        method: 'PUT',
        body: JSON.stringify(jsonObj),
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? 'Bearer ' + token : ''
        }
      })

      // Check for auth errors before processing response
      if (handleAuthError(res.status)) {
        return { response: res, status: res.status }
      }

      // Clone response before reading
      const clonedRes = res.clone()
      return { response: clonedRes, status: res.status }
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

  delete: async (jsonObj = {}, path = '', token = '') => {
    try {
      const url = process.env.REACT_APP_API_BASE_URL + path
      const res = await fetch(url, {
        method: 'DELETE',
        body: JSON.stringify(jsonObj),
        headers: {
          'Content-Type': 'application/json',
          Authorization: token ? 'Bearer ' + token : ''
        }
      })

      // Check for auth errors before processing response
      if (handleAuthError(res.status)) {
        return { response: res, status: res.status }
      }

      // Clone response before reading
      const clonedRes = res.clone()
      return { response: clonedRes, status: res.status }
    } catch (error) {
      console.error('API Error:', error)
      throw error
    }
  },

  post_with_params: async (jsonObj = {}, params, path = '', token = '') => {
    let query = await ApiCaller.serialize(params)

    const url =
      query != ''
        ? process.env.REACT_APP_API_BASE_URL + path + '?' + query
        : process.env.REACT_APP_API_BASE_URL + path
    // const url = process.env.REACT_APP_API_BASE_URL + path;
    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(jsonObj),
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? 'Bearer ' + token : ''
        //"isapplysubscription":true
      }
    })

    // if (_.includes([401, 403], res.status)) {
    //   window.location = process.env.PUBLIC_URL + "/login";
    // }
    if (_.includes([401], res.status)) {
      window.location = process.env.PUBLIC_URL + '/login'
    } else if (_.includes([403], res.status)) {
      alert('Logout')
      // return Logout()
    }
    return { response: await res, status: await res.status }
  },

  put_with_params: async (formData = {}, params, path = '', session = {}) => {
    let query = await ApiCaller.serialize(params)

    const url =
      query !== ''
        ? process.env.REACT_APP_API_BASE_URL + path + '?' + query
        : process.env.REACT_APP_API_BASE_URL + path

    // let res
    //         try{
    //            res  = await axios.put(url, JSON.stringify(formData),  {headers:{
    //             'Content-Type': 'application/json',
    //             Authorization: session.token ? 'Bearer ' + session.token : ''
    //           }})

    //         }
    //         catch(err){
    //         }
    //         finally{
    //           if (_.includes([401], res.status)) {
    //             window.location = process.env.PUBLIC_URL + '/login'
    //           } else if (_.includes([403], res.status)) {
    //             alert('Logout')
    //             //   return Logout()
    //           }
    //           return { response: await res, status: await res.status }
    //         }

    const res = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
        Authorization: session.token ? 'Bearer ' + session.token : ''
      }
    })

    if (_.includes([401], res.status)) {
      window.location = process.env.PUBLIC_URL + '/login'
    } else if (_.includes([403], res.status)) {
      alert('Logout')
      //   return Logout()
    }
    return { response: await res, status: await res.status }
  },

  post_formdata: async (formData = {}, path = '', token) => {
    const url = process.env.REACT_APP_API_BASE_URL + path
    const res = await fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        Authorization: token ? 'Bearer ' + token : ''
      }
    })

    if (_.includes([401, 403], res.status)) {
      // window.location = process.env.PUBLIC_URL + '/login'
      alert('Something went wrong, Please check iamge file and try again.')
    }
    return { response: await res, status: await res.status }
  },
  put_formdata: async (formData = {}, path = '', token) => {
    const url = process.env.REACT_APP_API_BASE_URL + path
    const res = await fetch(url, {
      method: 'PUT',
      body: formData,
      headers: {
        Authorization: token ? 'Bearer ' + token : ''
      }
    })

    if (_.includes([401, 403], res.status)) {
      window.location = process.env.PUBLIC_URL + '/login'
    }
    return { response: await res, status: await res.status }
  },
  put_statuschange: async (formData = {}, path = '', session) => {
    let query = await ApiCaller.serialize(formData)
    const url = process.env.REACT_APP_API_BASE_URL + path + '?' + query
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: session.token ? 'Bearer ' + session.token : ''
      }
    })

    if (_.includes([401, 403], res.status)) {
      window.location = process.env.PUBLIC_URL + '/login'
    }
    return { response: await res, status: await res.status }
  },
  getStatus: status => {
    switch (status) {
      case 1:
        return 'Active'
        break
      case 2:
        return 'Lost'
        break
      case 3:
        return 'Win'
        break
      case 5:
        return 'Disabled'
        break
      default:
        return 'Active'
        break
    }
  }
}
export default ApiCaller
